import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { platformApiFetch } from '../../api/client';

export const PLANS_QUERY_KEY = ['platform', 'plans'];

export function usePlans() {
  return useQuery({
    queryKey: PLANS_QUERY_KEY,
    queryFn: () => platformApiFetch('/api/platform/plans'),
  });
}

export function useCreatePlan() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body) =>
      platformApiFetch('/api/platform/plans', {
        method: 'POST',
        body,
        errorMessage: 'Failed to create plan',
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: PLANS_QUERY_KEY }),
  });
}

export function useUpdatePlan(uuid) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body) =>
      platformApiFetch(`/api/platform/plans/${uuid}`, {
        method: 'PATCH',
        body,
        errorMessage: 'Failed to update plan',
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: PLANS_QUERY_KEY }),
  });
}

export function useSyncPlan(uuid) {
  return useMutation({
    mutationFn: () =>
      platformApiFetch(`/api/platform/plans/${uuid}/sync-abacatepay`, {
        method: 'POST',
        errorMessage: 'Failed to sync plan',
      }),
  });
}
